import {IProduct, ProductManifestItem, ProductsManifest} from '../../../types/galleryTypes';
import {AddToCartState} from '@wix/wixstores-client-storefront-sdk/dist/es/src/services/AddToCartService/constants';
import {hasAutomaticDiscount, hasAnyDiscount} from '@wix/wixstores-client-core/dist/es/src/productOptions/productUtils';
import {IProductPreOrderAvailability} from '@wix/wixstores-client-core/dist/es/src/types/product';
import {IProductItem} from '@wix/wixstores-graphql-schema/dist/es/src/graphql-schema';

export const canAddProductToCart = (product: IProduct, productsManifest: ProductsManifest): boolean => {
  return product.isInStock || isPreOrderState(product, productsManifest);
};

export const isProductUnavailable = (manifestItem: ProductManifestItem | undefined): boolean => {
  return manifestItem?.addToCartState === AddToCartState.UNAVAILABLE;
};

export const isAddToCartEnabled = (product: IProduct, productsManifest: ProductsManifest): boolean => {
  const currentState = productsManifest[product.id].addToCartState;
  const isEnabledState = currentState === AddToCartState.ENABLED;
  return isEnabledState || isPreOrderState(product, productsManifest);
};

const isPreOrderState = (product: IProduct, productsManifest: ProductsManifest): boolean => {
  const {addToCartState} = productsManifest[product.id];
  return addToCartState === AddToCartState.PRE_ORDER;
};

export const isProductItemHasDiscount = (product: IProduct, selectedVariant?: IProductItem): boolean => {
  return hasAnyDiscount(product, selectedVariant);
};

const isRenderZeroPriceAllowedLegacy = (product: IProduct, allowFreeProducts: boolean): boolean => {
  return (
    !allowFreeProducts &&
    product.comparePrice === 0 &&
    !hasAutomaticDiscount(product) &&
    isProductItemHasDiscount(product)
  );
};

export const shouldRenderPrice = (product: IProduct, allowFreeProducts: boolean): boolean => {
  return (product.price !== 0 || allowFreeProducts) && !isRenderZeroPriceAllowedLegacy(product, allowFreeProducts);
};

export const shouldRenderOutOfStock = (product: IProduct): boolean => {
  const isOutOfStock = !product.isInStock;
  const isPreOrderItem = product.isManageProductItems
    ? product.productItemsPreOrderAvailability !== IProductPreOrderAvailability.NO_VARIANTS
    : product.inventory.availableForPreOrder;

  return isOutOfStock && !isPreOrderItem;
};
